import React from 'react';
import { CircleBackground } from './CircleBackground';
import { Slideshow } from './Slideshow';
export function Hero() {
  return <section className="relative w-full pt-[128px] overflow-hidden" data-id="element-178">
      <CircleBackground data-id="element-179" />
      <div className="w-full flex justify-center" data-id="element-180">
        <div className="w-full max-w-[1600px]" data-id="element-181">
          <Slideshow data-id="element-182" />
        </div>
      </div>
    </section>;
}